import { ATTENDANCE_STATUS } from './constants.js';
export const STATUS_LABELS = {
    [ATTENDANCE_STATUS.ANWESEND]: 'Anwesend',
    [ATTENDANCE_STATUS.VERSPAETET]: 'Verspätet',
    [ATTENDANCE_STATUS.FEHLT]: 'Fehlt',
    [ATTENDANCE_STATUS.EXCUSED_PRAXISMODUL]: 'Praxismodul',
};
export const STATUS_SYMBOLS = {
    [ATTENDANCE_STATUS.ANWESEND]: '✓',
    [ATTENDANCE_STATUS.VERSPAETET]: '⏰',
    [ATTENDANCE_STATUS.FEHLT]: '✗',
    [ATTENDANCE_STATUS.EXCUSED_PRAXISMODUL]: '🏫',
};
/**
 * True when a status should be excluded from attendance/quota statistics
 * (Klassenvergleich, Trends, Frühwarnung, Trödel). Praxismodul-Schüler waren
 * nie erwartet — sie als „fehlt" zu zählen würde Klassen-Quoten verzerren.
 * Used by `/backend/src/services/stats.ts` aggregations per ADR
 * `docs/decisions/praxismodul-and-auto-logout.md`.
 */
export function shouldExcludeFromAttendanceMetrics(status) {
    return status === ATTENDANCE_STATUS.EXCUSED_PRAXISMODUL;
}
//# sourceMappingURL=status.js.map